import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-584badd6")

_pushScopeId("data-v-584badd6")
const _hoisted_1 = { class: "drop-down" }
const _hoisted_2 = { class: "drop-down__title" }
const _hoisted_3 = { class: "drop-down__list" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _directive_click_outside_element = _resolveDirective("click-outside-element")

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString($props.title), 1),
    _createVNode("button", {
      class: ["btn drop-down__btn", { active: $setup.isActive }],
      onClick: _cache[1] || (_cache[1] = $event => ($setup.isActive = !$setup.isActive))
    }, [
      _createVNode("span", { title: $setup.getSelected }, _toDisplayString($setup.getSelected), 9, ["title"]),
      _createVNode(_component_svg_icon, { name: "arrowdown2" })
    ], 2),
    _withDirectives(_createVNode("ul", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.options, (option, optionInd) => {
        return (_openBlock(), _createBlock("li", {
          key: optionInd,
          class: "drop-down__item",
          onClick: $event => ($setup.select(option))
        }, _toDisplayString($setup.getValue(option)), 9, ["onClick"]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 512), [
      [_vShow, $setup.isActive]
    ])
  ], 512)), [
    [_directive_click_outside_element, () => ($setup.isActive = false)]
  ])
})